import React, { Fragment } from 'react';
import { CATEGORY_ICONS } from './shopIcons';
import { StorefrontCategory } from '../../utils/storefront';
interface ShopCategoryStripProps {
  categories: StorefrontCategory[];
  active: string | null;
  onSelect: (label: string, prompt: string) => void;
}
/** The Discover ribbon, skinned to the merchant's own departments. */
export function ShopCategoryStrip({
  categories,
  active,
  onSelect
}: ShopCategoryStripProps) {
  if (categories.length === 0) return null;
  // With a full set the segments share the ribbon evenly; with only a few they
  // keep a natural width and the ribbon centres them instead of stretching.
  const spread = categories.length >= 6;
  const segment = spread ? 'flex-1 min-w-0' : 'w-[108px] flex-shrink-0';
  return <nav aria-label="Browse categories" className={`flex items-stretch p-1.5 bg-white rounded-2xl border border-slate-100 shadow-sm ${spread ? 'w-full' : 'mx-auto max-w-full overflow-x-auto no-scrollbar justify-center'}`} data-id="element-4750" data-mp="12cs9iare6flu">
      {categories.map((item, idx) => {
      const Icon = CATEGORY_ICONS[item.icon];
      const isActive = active === item.label;
      return <Fragment key={item.name} data-id="element-4751" data-mp="x085ncd8vqvq" data-mpi={idx}>
            <button onClick={() => onSelect(item.label, item.prompt)} aria-current={isActive} className={`relative ${segment} flex flex-col items-center justify-center gap-2 px-1 py-2.5 rounded-xl transition-colors duration-150 ease-out group ${isActive ? 'bg-[var(--mp-07)] text-[var(--mp-deep)]' : 'text-slate-500 hover:bg-[var(--mp-05)] hover:text-[var(--mp-d)]'}`} data-id="element-4752" data-mp="ryivs01rdj98">
              <Icon className={`w-[18px] h-[18px] transition-colors duration-150 ease-out ${isActive ? 'text-[var(--mp)]' : 'text-slate-400 group-hover:text-[var(--mp)]'}`} strokeWidth={1.5} data-id="element-4753" data-mp="15zd5qn4gfsa0" />
              <span className="text-[10px] font-semibold uppercase tracking-[0.12em] truncate max-w-full" data-id="element-4754" data-mp="1ylxxvpsr88em">
                {item.label}
              </span>
              {/* Accent marks the active department */}
              {isActive && <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-6 h-[3px] rounded-full bg-[var(--ma)]" data-id="element-4755" data-mp="3j5jlzljflc90" />}
            </button>
            {idx < categories.length - 1 && <div className="w-px self-center h-7 bg-slate-100 flex-shrink-0" data-id="element-4756" data-mp="3a53iic2ou545" />}
          </Fragment>;
    })}
    </nav>;
}